import axios from 'axios';

const instance = axios.create({
  baseURL: "https://apinekros-demo.sig-norba.com",
  withCredentials: true,
});

export default instance;